/**
 * Motivo do bloqueio de matrícula devolvido pela API.
 *
 * `NO_ACTIVE_OFFER` é o único que não representa um bloqueio de regra: significa que o produto está ativo
 * mas não tem nenhuma oferta aberta, então não existe data de abertura para exibir (TS-5314).
 */
export const NO_ACTIVE_OFFER_REASON = 'NO_ACTIVE_OFFER' as const

export interface EnrollmentWindowApiResponse {
  blocked: boolean
  reason: string | null
  opensAt: string | null
  startDate: string | null
  hasInterest: boolean
}

export interface EnrollmentWindowModel {
  blocked: boolean
  reason: string | null
  opensAt: string | null
  startDate: string | null
  hasInterest: boolean
}

export interface RegisterInterestApiResponse {
  hasInterest: boolean
  reason: string
  status: string
  createdAt: string
}

export interface RegisterInterestModel {
  hasInterest: boolean
  reason: string
  status: string
  createdAt: string
}

/**
 * Seleciona o par de rotas usado pelo serviço.
 *
 * - `byProduct: false` (padrão) → rotas por oferta, `/v2/user/courses/{courseId}/…`
 * - `byProduct: true` → rotas por produto, `/catalog/v2/products/{productId}/…`
 *
 * As duas existem porque produto e oferta são ambos `Integer` no backend: um único path não conseguiria
 * distinguir os ids, e adivinhar registraria interesse na entidade errada.
 */
export interface EnrollmentWindowTargetOptions {
  byProduct?: boolean
}
